export const HomePageRef = [
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/1.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/2.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/3.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/4.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/5.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/6.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/7.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/8.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/9.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/10.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/11.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/12.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/13.png',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/14.png',
    },
    // {
    //     url: 'https://static.igem.wiki/teams/4241/wiki/new-front-page/15.png',
    // },

    
]